<template>
  <pre v-if="isDebug">
    {{ debug }}
     <slot></slot>
  </pre>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import { ConfigModule } from "@/store/modules/config";

@Component
export default class Debug extends Vue {
  @Prop({})
  debug: any;

  get isDebug() {
    return ConfigModule.debug;
  }
}
</script>

<style scoped>
pre {
  white-space: pre-wrap;
  overflow-x: auto;
  tab-size: 1;
  background-color: lightgray;
  font-size: 0.7rem;
}
</style>
